


/**
* The result of setting a schedule date
*/
export enum SetScheduleResult{
    /**
    * The schedule was successfully set
    */
    Success = 0,
    /**
    * The session was canceled before the schedule could be set
    */
    SessionCanceled = 1,
    /**
    * The schedule date to be set is for today and the PreventSameDayScheduling flag is enabled
    */
    SameDaySchedulingForbidden = 2
}

